import styled from "styled-components";

export const PaneBody = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    flex: 1;
    min-width: 0;
    min-height: 0;
    overflow: hidden;
    gap: 20px;
`;
